<template>
    <section class="container">
        <Carousel style="width:650px" v-model="value1" trigger="hover" autoplay :autoplay-speed="speed" indicator-position="none">
            <CarouselItem v-for="(banner, index) in bannerList" :key="index">
                <div>
                    <img class="banner pointer" :src="banner.imgUrl" alt=""
                         :data-id="banner.articleId" :data-article="banner.articleType"
                         :data-url="banner.linkUrl"  :data-type="banner.linkType"
                         @click="openUrl" >
                </div>
            </CarouselItem>
        </Carousel>
        <!-- v-if="!$store.state.user" -->
        <!-- <div class="LoginM unLogin" v-if="!$store.state.isLogin" >
            <div class="mod-entry-user-hover mod-entry-nologin">
                <p class="mod-entry-nologin-tips">请先登录后进行学习</p>
                <div class="mod-entry-nologin-img"></div>
            </div>
            <a href="javascript:void(0);" @click="loginClick" class="btn-default mod-entry-login js-login-op">登录</a>
        </div> -->
        <div class="AdsM">
            <!-- <div class="flex-row blue pointer">
                <div class="col-40 text-center">
                    <img src="../../assets/sign.png" alt="">
                </div>
                <div class="col-60 text-left">
                    <span @click="tabClick('/Sign')">培训报名</span>
                </div>
            </div>
            <div class="flex-row blue pointer">
                <div class="col-40 text-center">
                    <img src="../../assets/icbc.png" alt="">
                </div>
                <div class="col-60 text-left">
                    <span @click="tabClick('/Transfer')">缴费说明</span>
                </div>
            </div>
            <div class="flex-row blue pointer">
                <div class="col-40 text-center">
                    <img src="../../assets/icon.png" alt="">
                </div>
                <div class="col-60 text-left">
                    <span @click="tabClick('/Lecture')">使用说明</span>
                </div>
            </div>
            <div class="flex-row blue pointer">
                <div class="col-40 text-center">
                    <img src="../../assets/phone.png" alt="">
                </div>
                <div class="col-60 text-left">
                    <span @click="tabClick('/Contact')">关于我们</span>
                </div>
            </div> -->
            <!-- 根据需求隐藏 -->
            <!-- <div class="qrCodeM">
                <div  class="arrow-r pointer" @click="close">
                    <Icon type="md-arrow-dropright"/>
                </div>
                <div class="code">
                  <Poptip class="code" style="margin-top: 7px" trigger="hover" placement="right">
                    <img :src="androidCodeUrl" alt="">
                    <div class="api" slot="content">
                      <img style="width: 140px;height: 140px;margin: 20px;" :src="androidCodeUrl" alt="">
                    </div>
                  </Poptip>
                </div>
                <div class="intro" style="margin:0 auto">
                    培训学习安卓APP下载
                </div>
                <Poptip class="code" style="margin-top: 7px" trigger="hover" placement="right">
                    <img :src="iosCodeUrl" alt="">
                    <div class="api" slot="content">
                      <img :src="iosCodeUrl" alt="" style="width: 140px;height: 140px;margin: 20px;">
                    </div>
                </Poptip>
                <div class="intro" style="margin:0 auto">
                    培训学习苹果APP下载
                </div>
            </div> -->
        </div>
        <!-- <div class="borderM hidden" @click="open">
            <Icon  type="md-arrow-dropleft"/>
        </div> -->
        <!-- <BackTop :bottom="bottom" class="topM"></BackTop> -->
    </section>
</template>

<script>
    export default {
        name: "Swiper",
        data () {
            return {
                bannerList: [],
                iosCodeUrl: [],
                androidCodeUrl: [],
                value1: 0,
                speed: 4000,
                bottom: 50
            }
        },
        created(){

            this.listBanner();
        },
        methods: {
            listBanner(){
                var that = this;
                var modelData = {
                    "page": "1",
                    "size": "10",
                    "viewPosition":1
                };
                var modelData1 = {};
                var modelData2 = {};
                this.$http({
                    url: that.webhost + 'banner/list',
                    method: 'POST',
                    data: modelData
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        that.bannerList = data.data;
                    }
                }),
                this.$http({
                    url: that.webhost + 'code/android',
                    method: 'Get'
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        that.androidCodeUrl = data.data.picture;
                    } else {
                        that.$Message.error(data.msg)
                    }
                }),

                this.$http({
                    url: that.webhost + 'code/ios',
                    method: 'Get'
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        that.iosCodeUrl = data.data.picture;
                    } else {
                        that.$Message.error(data.msg)
                    }
                })
            },
            openUrl(e){
              if (+e.currentTarget.dataset.type == 1) {
                    window.open(e.currentTarget.dataset.url);
                }else {
                  switch (+e.currentTarget.dataset.article) {
                    case 1:
                      this.$router.push('/RuleArtical/' + e.currentTarget.dataset.id);
                      break;
                    case 2:
                      this.$router.push('/WorkArtical/' + e.currentTarget.dataset.id);
                      break;
                    case 3:
                      this.$router.push('/Interview/' + e.currentTarget.dataset.id);
                      break;
                  }
                }
            },
            close(){
                $('.AdsM').addClass('fadedOut').removeClass('fadedIn');
                setTimeout(function () {
                    $('.AdsM').addClass('hidden');
                    $('.borderM').addClass('fadedIn').removeClass('hidden');
                },1000);
            },
            open(){
                $('.borderM').addClass('hidden').removeClass('fadedIn');
                $('.AdsM').removeClass('fadedOut').removeClass('hidden').addClass('fadedIn');
            },
            loginClick(){
                this.$store.commit('login');
            }
        }
    }
</script>

<style scoped>
    .container{
        margin-top: 10px;
        min-width: 650px;
        position: relative;
        margin: 0 !important;
    }
    .banner{
        width: 100%;
        height: 330px;
        /* margin: 0 auto; */
    }
    .LoginM{
        /*position: absolute;*/
        /*top: 50%;*/
        /*transform: translate(0, -35%);*/
        position: absolute;
        top: 9%;
        left: 20px;
        /*visibility: hidden;*/
        overflow: hidden;
        display: inline-block;
        height: 80px;
        line-height: 78px;
        width: 50px;
        vertical-align: top;
        text-align: center;
        border-radius: 3px;
    }
    .unLogin {
        line-height: 50px;
        background-color: #fff;
        height: auto;
        box-shadow: 0 1px 10px 3px rgba(0,0,0,.1);
    }
    .mod-entry-user-hover {
        width: 220px;
        background-color: #fff;
        line-height: 1.5;
        padding: 15px 0 25px;
    }
    .unLogin .mod-entry-user-hover {
        display: block;
    }
    .mod-entry-nologin {
        padding: 17px 0 10px;
    }
    .mod-entry-nologin-tips {
        font-size: 16px;
        color: #999;
    }
    .mod-entry-nologin-img {
        width: 170px;
        height: 130px;
        background: url(../../assets/hat.png) no-repeat;
        /* margin: 10px auto auto; */
    }
    .mod-entry-login {
        display: inline-block;
        line-height: 50px;
        width: 200px;
        margin-bottom: 10px;
        font-size: 16px;
        border-radius: 3px;
    }
    .btn-default {
        background-color: #23b8ff;
        color: #fff;
    }
    .btn-default:active{
        opacity: .79;
    }
    .ivu-carousel{
        /*min-height: 300px;*/
    }
    .AdsM{
        /*position: absolute;*/
        /*right: 20px;*/
        /*top: 20px;*/
        position: fixed;
        right: 20px;
        top: 200px;
        width: 145px;
        z-index: 1;
        box-shadow: 0 1px 10px 3px rgba(0,0,0,.1);
    }
    .blue{
        background-color: #23b8ff;
        color: #fff;
        height: 34px;
        line-height: 34px;
        font-size: 15px;
        border-radius: 2px;
        margin-top: 1px;
    }
    .AdsM .blue img{
        width: 22px;
        position: relative;
        top: 6px;
        right: -2px;
    }
    .qrCodeM{
        padding: 20px 0 10px;
        text-align: center;
        /* width: 100%; */
        background: #fff;
        position: relative;
    }
    .qrCodeM img{
        width: 80px;
    }
    .intro{
        width: 100px;
        /* margin: auto; */
        font-size: 14px;
        line-height: 20px;
    }
    .fadedOut {
        animation: fadeOutRight 1s 0s ease-in-out 1;
    }
    .fadedIn{
        animation: fadeInRight 1s 0s ease-in-out 1;
    }
    /*.topM{*/
        /*margin-top: 10px;*/
    /*}*/
    /*.topM img{*/
        /*width: 36px;*/
        /*height: 36px;*/
    /*}*/
    .top{
        padding: 2px 4px;
        background: #23b8ff;
        opacity: .87;
        color: #fff;
        text-align: center;
        border-radius: 2px;
    }
    .arrow-r{
        font-size: 30px;
        position: absolute;
        left: 0;
        top: 39%;
    }
    .hidden{
        visibility: hidden;
    }
    .borderM{
        width: 12px;
        height: 427px;
        line-height: 427px;
        font-size: 12px;
        background: #00b5ff;
        box-shadow: 0 1px 1px 1px #f1f1f1;
        /*position: absolute;*/
        /*right: 0;*/
        /*top: 20px;*/
        position: fixed;
        right: 0px;
        top: 200px;
        cursor: pointer;

    }
</style>



// WEBPACK FOOTER //
// src/views/components/Swiper.vue